
export const Constants =
{
    ALERT_TIMEOUT: 3000,
    // region "Environment"
    ENV_POINTS_VALUE_KEY: "PointValue",
    ENV_DOLLAR_VALUE_KEY: "DollarValue",
    ENV_GIVIAPP_MARKETBANNER_VALUE_KEY: "GiviAppMarketBannerValue",
    ENV_GIVIAPP_ACESS_LIMIT: "GiviAppAccessLimit",
    ENV_GIVIAPP_SPECIAL_COUPON: "GiviAppSpecialCoupon",
    ENV_GIVIAPP_OPEN_LINK_VALUE_KEY: "GiviAppOpenLinkValue",
    ENV_GIVIAPP_REFRESH_CACHE: "GiviAppRefreshCache",
    ENV_GIVIAPP_UPLOAD_SERVICE: "GiviAppUploadService",
    // endregion

}
